import React from "react";
import { Link } from "react-router-dom";
import { Youtube, Linkedin } from "lucide-react";
import { creditLabel } from "@/data/credits";

export default function Footer() {
  return (
    <footer className="mt-20 border-t border-[var(--border-warm)] bg-[var(--muted-surface)]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid gap-6 md:grid-cols-3 text-sm">
        <div>
          <img src="/csi-logo.jpg" alt="Converged Security Institute" className="h-14 w-auto mb-3"/>
          <p className="text-zinc-700 max-w-sm">A governed professional qualification pathway for security practitioners, IT professionals, managers and organisational leaders.</p>
          <div className="flex flex-wrap gap-2 mt-4">
            <a href="https://www.youtube.com/@convergedsecurity" target="_blank" rel="noreferrer" className="chip inline-flex items-center gap-1.5 text-xs" data-testid="footer-youtube">
              <Youtube size={14} className="text-red-600"/> Masterclasses on YouTube
            </a>
            <a href="https://www.linkedin.com/company/converged-security" target="_blank" rel="noreferrer" className="chip inline-flex items-center gap-1.5 text-xs" data-testid="footer-linkedin">
              <Linkedin size={14} className="text-[#0A66C2]"/> Follow on LinkedIn
            </a>
          </div>
        </div>
        <div>
          <div className="eyebrow mb-2">Programmes</div>
          <ul className="space-y-1 text-zinc-800">
            <li>CSCE · Foundation · {creditLabel("CSCE")}</li>
            <li>CSP · Professional · {creditLabel("CSP")}</li>
            <li>CSL · Leadership · {creditLabel("CSL")}</li>
            <li>CCSO · Executive · {creditLabel("CCSO")}</li>
            <li>PGDCSL · Postgraduate · {creditLabel("PGDCSL")}</li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-2">Institute</div>
          <ul className="space-y-1 text-zinc-800">
            <li><Link to="/instructors" className="hover:underline" data-testid="footer-instructors">Instructors</Link></li>
            <li><Link to="/publications" className="hover:underline" data-testid="footer-publications">Publications &amp; CSF Standards</Link></li>
            <li><Link to="/policies" className="hover:underline" data-testid="footer-policies">Policies &amp; Governance</Link></li>
            <li><a href="/documents/pgdcsl-programme-governance-manual.pdf" target="_blank" rel="noreferrer" className="hover:underline" data-testid="footer-manual">PGDCSL Programme &amp; Governance Manual</a></li>
            <li><Link to="/accreditation" className="hover:underline" data-testid="footer-accreditation">Accreditation &amp; trustmarks</Link></li>
            <li><Link to="/organisations" className="hover:underline" data-testid="footer-organisations">For organisations</Link></li>
            <li><Link to="/ambassadors" className="hover:underline" data-testid="footer-ambassadors">Ambassador Programme</Link></li>
            <li><a href="https://gcsb.uk/accreditation" target="_blank" rel="noopener noreferrer" className="hover:underline" data-testid="footer-gcsb-accreditation">GCSB accreditation ↗</a></li>
            <li><Link to="/verify" className="hover:underline" data-testid="footer-verify">Verification</Link></li>
            <li><Link to="/cpd-renewal" className="hover:underline" data-testid="footer-cpd-renewal">CPD &amp; renewal</Link></li>
            <li><a href="https://gcsb.uk/cpd" target="_blank" rel="noopener noreferrer" className="hover:underline" data-testid="footer-gcsb-cpd">Submit CPD (GCSB) ↗</a></li>
            <li><Link to="/join-faculty" className="hover:underline" data-testid="footer-join-faculty">Join the faculty</Link></li>
            <li>Contact: info@convergedsecurity.es</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--border-warm)] py-4 text-center text-xs text-zinc-600">
        © {new Date().getFullYear()} Converged Security Institute. All rights reserved. Programme content, examinations and study materials are protected by copyright and may not be reproduced or distributed without written permission.
      </div>
    </footer>
  );
}
